export default class BaseModel {

  emptyNote = '/'
  isNew = false

  prepareQueryForSearch (model) {
    let params = {
      limit: 100
    }
    for (let property in model) {
      if (model.hasOwnProperty(property)) {
        if (model[property] instanceof Object) {
          if (model[property].data !== undefined) {
            if (model[property].data.length > 0) {
              params[property + '-id'] = []
              model[property].data.forEach(function (value) {
                params[property + '-id'].push(value.id)
              })
            }
          }
        } else {
          if (model[property] !== '') {
            params[property] = model[property]
          }
        }
      }
    }

    return params
  }
}



// WEBPACK FOOTER //
// ./src/models/baseModel.js